import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums'
import LoadingState from '../components/LoadingState'

const Announcements = lazy(() => import('../pages/pages/Announcements'))

export default [
  {
    path: '/announcements',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <Announcements />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
